import type {
  ShareBetData,
  QuickbetShare,
  TicketShare,
  BetSlipShare,
  BetLoopShare,
  KambiSportsShare,
} from '@core/Areas/ShareBet/types'

export function isTicketShareData(share: ShareBetData): share is TicketShare {
  return share.contextType === 'ticket'
}

export function isBetLoopShareData(share: ShareBetData): share is BetLoopShare {
  return share.contextType === 'betloop'
}

export function isQuickbetShareData(share: ShareBetData): share is QuickbetShare {
  return share.contextType === 'quickbet'
}

export function isBetSlipShareData(share: ShareBetData): share is BetSlipShare {
  return share.contextType === 'betslip'
}

export function isKambiSportsShareData(share: ShareBetData): share is KambiSportsShare {
  return share.contextType === 'kambi'
}
